<template>
  <v-container class="input-text-size">
      <ApportionmentTransactionCriteria
      :baseCrudKey="baseCrudKey"
      @loadCRUDList="getApportionmentRecords"
      :totalNegativeCount="totalNegativeCount"/>
  <CRUDList
      ref="crudList"
      :headers='headers'
      :displayTopPagination="false"
      :canEdit="true"
      :canSave="true"
      :showDate="false"
      :canAdd="true"
      :baseCrudKey="baseCrudKey"
      :enableFixedHeaders="true"
      @emitSelectedItem="emitSelectedItem"
      :dialogHeaderName="dialogHeaderName"
      :defaultSortBy="defaultSortBy"
      @loadCRUDList="getApportionmentRecords"
      @upsertItem="upsertTransaction"
      :footerTotalDisplayColumnWise="totalOfTaxes"
      tableWrapperDynamicClassname='elevation-3 ma-3 pa-3 taxroll-table-wrapper'
      tableDynamicClassname='taxroll-custom-table'
      tableDynamicHeight='350'
      dialogDynamicWidth="700"
      :loadingData="gridLoading.flag"
      :loadingText="gridLoading.text"
      :createNewItem="newItemDialog"
      :variableToChangeRowBgColor="[{ varName: 'isNegativeAmount', varCol: '#f25c54' }]"

  >
  <template v-slot:[`editedItem`]="{}">
        <ApportionmentEditedItem
        :baseCrudKey="baseCrudKey"
        />
      </template>
  </CRUDList>
  <v-dialog v-model="openGLDialog" max-width="350">
      <v-card>
        <v-card-title class="input-text-size">Enter Details</v-card-title>
        <v-card-text class="input-text-size" >
          <v-container>
          <v-row dense  hide-details>
            <v-col cols="4">
              <ClarionDateControl class="input-text-size"
                  label="Ax From date" :isRequired="false" :isToggle="false"
                  v-model="criteriaState.fromDate"/>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="4">
              <ClarionDateControl class="input-text-size"
                  label=" Ax To Date" :isRequired="false" :isToggle="false"
                    v-model="criteriaState.toDate"/>
            </v-col>
          </v-row>
          <v-row dense  hide-details>
            <v-col cols="4" dense>
              <ClarionDateControl class="input-text-size"
                  label="GL Business Date" :isRequired="false" :isToggle="false"
                    v-model="criteriaState.glBusinessDate"/>
            </v-col>
          </v-row>
          <v-row  dense>
                <v-checkbox v-model="isUpdateGL" hide-details label=" Update GL"></v-checkbox>
            </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="input-text-size">
          <v-btn color="primary" small @click="updateGL"
            >Ok</v-btn
          >
          <v-btn small @click="closeGLDialog">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  <div>
        <v-row class="mt-2" >
          <v-col cols="2">
            <v-btn
            color="primary"
            small
            rounded
            class="mb-2 ml-8"
            @click="printMoneyFromRecap"
            >
              "Money From" Recap
            </v-btn>
          </v-col>
          <v-col cols="2">
            <v-btn
            color="primary"
            small
            rounded
            class="mb-2 ml-7"
            @click="printSectionAReport"
            >
              Section A
            </v-btn>
          </v-col>
          <v-col cols="2">
            <v-btn
            color="primary"
            small
            rounded
            class="mb-2 ml-0"
            @click="openGLUpdateDialog"
            :disabled= this.criteriaState.typeOfRecord
            >
              Update GeneraL Ledger
            </v-btn>
          </v-col>
          <v-col cols="2">
            <v-btn
            color="primary"
            small
            rounded
            class="mb-2 ml-5"
            @click="openEONReportDialog"
            >
              Estimate of Needs
            </v-btn>
          </v-col>
          <v-col cols="3">
            <v-btn
            color="primary"
            small
            rounded
            class="mb-2 ml-5"
            @click="printAlcoholicBeverageTaxReport"
            >
              ALCOHOLIC-Beverage Allocation Report
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="mt-2">
          <v-col cols="2">
            <v-btn
              color="primary"
              small
              rounded
              class="mb-2 ml-8"
              @click="openCoverPageDialog"
            >
              Cover Page
            </v-btn>
          </v-col>
          <v-col cols="2">
            <v-btn
            color="primary"
            small
            rounded
            class="mb-2 ml-7"
            @click="printBackPageSummary"
            >
              Back Page
            </v-btn>
          </v-col>
          <v-col cols="2">
            <v-btn
            color="primary"
            small
            rounded
            class="mb-2 ml-0"
            @click="openCreateWarrantDialog()"
            :disabled= "this.criteriaState.typeOfRecord || !this.isprintWarrentNumber
            || this.isLocked"
            >
              Build Warrant Records
            </v-btn>
          </v-col>
          <v-col cols="2">
            <v-btn
            color="primary"
            small
            rounded
            class="mb-2 ml-6"
            @click="printFourMillReport"
            >
              4 Mill Report
            </v-btn>
          </v-col>
          <v-col cols="4">
            <v-btn
            color="primary"
            small
            rounded
            class="mb-2 ml-10"
            @click="printMotorVehicleTaxreport"
            >
              Motor Vehicle Allocation Report
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">
          </v-col>
          <v-col cols="2">
            <v-btn
            color="primary"
            small
            rounded
            class="mb-2"
            :disabled= "!this.isprintWarrentNumber || this.isLocked"
            @click="assignNexWarrantNumbers"
            >
              Assign Warrant Numbers
            </v-btn>
          </v-col>
        </v-row>
</div>
  <v-dialog v-model="warrantDialog" max-width="400">
    <v-card>
      <v-card-title class="input-text-size">
        you are creating Warrant for the date range:
      </v-card-title>
      <v-card-text class="input-text-size">
        <v-container>
          <v-row dense  hide-details>
            <v-col cols="4">
              <ClarionDateControl class="input-text-size"
                  label="From date" :isRequired="false" :isToggle="false"
                  v-model="criteriaState.remitFromDate"/>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="4">
              <ClarionDateControl class="input-text-size"
                  label="To Date" :isRequired="false" :isToggle="false"
                    v-model="criteriaState.remitToDate"/>
            </v-col>
          </v-row>
          <v-row dense  hide-details>
            <v-col cols="4" dense>
              <ClarionDateControl class="input-text-size"
                  label="Warrant Date" :isRequired="false" :isToggle="false"
                    v-model="criteriaState.warrantDate"/>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="input-text-size">
        <v-btn @click="createWarrants">
          Ok
        </v-btn>
        <v-btn small @click="closeWarrantDialog">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="EONReportDialog" max-width="300">
    <v-card>
      <v-card-title class="input-text-size">
        Dates for Estimate of Needs Report
      </v-card-title>
      <v-card-text class="input-text-size">
        <v-container>
          <v-row dense  hide-details>
            <v-col cols="12">
              <ClarionDateControl class="input-text-size"
                  label="Treasurer Date" :isRequired="false" :isToggle="false"
                  v-model="criteriaState.treasurerDate"/>
            </v-col>
            </v-row>
            <v-row dense  hide-details>
            <v-col cols="12">
              <ClarionDateControl class="input-text-size"
                  label="Clerk Date" :isRequired="false" :isToggle="false"
                    v-model="criteriaState.clerkDate"/>
            </v-col>
          </v-row>
          <v-row dense  hide-details>
            <v-col cols="12" dense>
              <ClarionDateControl class="input-text-size"
                  label="Excise Board Date" :isRequired="false" :isToggle="false"
                    v-model="criteriaState.exciseBoardDate"/>
            </v-col>
          </v-row>
          <v-row dense  hide-details>
            <v-col cols="12" dense>
              <v-checkbox v-model="criteriaState.isCreateAppropriations" hide-details label="Create Appropriations" />
            </v-col>
          </v-row>
          <v-row dense  hide-details>
            <v-col cols="12" dense>
              <v-checkbox v-model="criteriaState.isItSpecialApportionment" hide-details label="Print Special Apportionment" />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="input-text-size">
        <v-btn @click="printEONReport">
          Ok
        </v-btn>
        <v-btn small @click="closeEONReportDialog">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="coverPageDialog" max-width="300">
    <v-card>
      <v-card-title class="input-text-size">
        Cover Page Information
      </v-card-title>
      <v-card-text class="input-text-size">
        <v-container>
          <v-row dense  hide-details>
            <v-col cols="10">
              <v-text-field
                label="Cover Page Title"
                v-model="coverPageTitle"
              />
            </v-col>
            <v-row dense  hide-details>
            <v-col cols="10">
              <ClarionDateControl class="input-text-size"
                  label="Date Received" :isRequired="false" :isToggle="false"
                    v-model="coverPageDateReceived"/>
            </v-col>
            </v-row>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="input-text-size">
        <v-btn @click="printCoverPageSummary">
          Ok
        </v-btn>
        <v-btn small @click="closeCoverPageDialog">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</v-container>
</template>

<script>

import {
  mapGetters, mapMutations, mapActions, mapState,
} from 'vuex';
import CRUDList from '../../common/base/crud-2.0/CRUDList.vue';
import { apportionmentTransactionListHeaders } from '../apportionmentutils/apportionmentTableHeader';
import ApportionmentTransactionCriteria from './apportionmentTransactionCriteria.vue';
import {
  amountFormat, amountToNumber, defaultGridLoading, manageGridLoading,
} from '../../../util/shared/vue-global';
import ClarionDateControl from '../../common/ClarionDateControl.vue';
import { generateQueryString } from '../../common/base/report/report-util';
import { clients } from '../../../util/clients';
import { toIsoDate, toShortDate } from '../../../util/shared/tmc-global';
import ApportionmentEditedItem from './apportionmnetEditItem.vue';

const { backendRest } = clients.direct;

export default {
  data() {
    return {
      fromDateValue: '',
      toDateValue: '',
      headers: apportionmentTransactionListHeaders,
      gridLoading: defaultGridLoading(),
      warrantDialog: false,
      baseCrudKey: 'approtionmentTab',
      dialogHeaderName: 'APPORTIONMENT RECORD',
      EONReportDialog: false,
      openGLDialog: false,
      isUpdateGL: true,
      isprintWarrentNumber: false,
      isLocked: false,
      coverPageDialog: false,
      totalOfTaxes: [null, null, null, null, null, null, null, 'Total :'],
      coverPageDateReceived: '',
      coverPageTitle: '',
      totalNegativeCount: null,
    };
  },
  props: {
    // baseCrudKey: {
    //   type: String,
    //   default: '',
    // },
  },
  created() {
    // this.getApportionmentReportsBalancingRecord();
    this.loadGlobalConfig();
  },
  components: {
    CRUDList,
    ApportionmentTransactionCriteria,
    ClarionDateControl,
    ApportionmentEditedItem,
  },
  computed: {
    ...mapGetters('base/crud', ['criteria', 'item']),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    // ...mapGetters([
    //   'todaysDate',
    // ]),
    ...mapState({
      storeSelItems:
      (state) => state.apportionment.apportionmentTab.selectedItems || [],
    }),
    selectedItems: {
      get() {
        return this.storeSelItems;
      },
      set(value) {
        this.setSelectedItems(value);
      },
    },
    defaultSortBy() {
      return [
        {
          column: 'fundNo',
          direction: 'asc',
        },
        {
          column: 'sourceNo',
          direction: 'asc',
        },
        {
          column: 'unit',
          direction: 'asc',
        },
      ];
    },
  },
  methods: {
    ...mapActions('SystemConfig', [
      'loadConfig',
    ]),
    ...mapActions(['reAuth', 'flashError']),
    ...mapActions(['reAuth', 'flashWarn']),
    ...mapMutations('base/crud', [
      'setCriteria', 'setItems',
    ]),
    // ...mapMutations('apportionment/apportionmentRemitWarrants', [
    //   'setSelectedItems',
    //   'setTotalLockedRecordsCount',
    // ]),
    ...mapActions('apportionment/apportionmentRemitWarrants', [
      'remitWarrantsBuildRecords',
    ]),
    ...mapActions('apportionment/apportionmentTab', [
      'assignWarrantNumbers',
    ]),
    manageGridLoading,
    ...mapMutations('apportionment/apportionmentTab', [
      'setSelectedItems',
    ]),
    ...mapActions('apportionment/apportionmentTab', [
      'loadApportionmentRecords',
      'upsertForLockRecords',
      'upsertApportionmentTransaction',
      'deleteRecordFromApportionment',
      'apportionmnetUpdateRecordsInGL',
      'apportionmentReportTotals',
      'createEonAppropriations',
    ]),
    async getApportionmentRecords() {
      const { baseCrudKey } = this;
      const convertToIsoFromDate = this.criteriaState.fromDate
        ? toIsoDate(this.criteriaState.fromDate) : null;
      const convertToIsoToDate = this.criteriaState.toDate
        ? toIsoDate(this.criteriaState.toDate) : null;
      const criteria = {
        // ...this.criteriaState,
        ...{
          fromDate: convertToIsoFromDate,
          toDate: convertToIsoToDate,
          limit: this.criteriaState.limit,
          skip: this.criteriaState.skip,
          sortBy: this.criteriaState.sortBy,
          typeOfRecord: this.criteriaState.typeOfRecord,
        },
      };
      // const criteria = this.criteriaState;
      manageGridLoading(this, true, 'Searching...');
      const totalData = await this.apportionmentReportTotals({ criteria });
      this.totalNegativeCount = totalData[0].negativeRecordsCount;
      if (totalData.length > 0) {
        const total = totalData[0];
        this.totalOfTaxes = [null, null, 'Total :', null, null, null, null, amountFormat(total.totalAmount)];
      } else {
        this.totalOfTaxes = [null, null, 'Total :', null, null, null, null, amountFormat(0.00)];
      }
      const res = await this.loadApportionmentRecords({ criteria, baseCrudKey }).finally(() => {
        manageGridLoading(this, false);
      });
      const lockedRecordsCount = res.filter((item) => item.isLocked);
      if (lockedRecordsCount.length > 0) {
        this.isLocked = true;
      } else {
        this.isLocked = false;
      }
    },
    async loadGlobalConfig() {
      const apportionmentSetting = await this.loadConfig({ requiredScope: 'apportionmentConfig' });
      this.isprintWarrentNumber = ((apportionmentSetting || [])[0]
        .configuration.treasurerPrintsWarrants);
    },
    getLastWeekday(dateStr) {
      const isoStr = toIsoDate(dateStr);
      const date = new Date(isoStr);
      const dayOfWeek = date.getUTCDay(); // 0=Sunday, 6=Saturday
      if (dayOfWeek === 6) {
        date.setUTCDate(date.getUTCDate() - 1);
      } else if (dayOfWeek === 0) {
        date.setUTCDate(date.getUTCDate() - 2);
      }
      return toShortDate(date);
    },
    openGLUpdateDialog() {
      const lastWeekday = this.getLastWeekday(this.criteriaState.toDate);
      this.$set(this.criteriaState, 'glBusinessDate', lastWeekday);
      this.openGLDialog = true;
    },
    closeGLDialog() {
      this.openGLDialog = false;
    },
    closeCoverPageDialog() {
      this.coverPageDialog = false;
    },
    async upsertTransaction(item) {
      const toDate = toIsoDate(item.toDate);
      const fromDate = toIsoDate(item.fromDate);
      const { baseCrudKey } = this;
      const updatedItem = { ...item, toDate, fromDate };
      updatedItem.amount = amountToNumber(updatedItem.amount);
      if (updatedItem.amount < 0) {
        updatedItem.isNegativeAmount = true;
      } else {
        updatedItem.isNegativeAmount = false;
      }
      updatedItem.resaleAmount = amountToNumber(updatedItem.resaleAmount);
      const response = await this.upsertApportionmentTransaction(
        { item: updatedItem, baseCrudKey },
      );
      return response;
    },
    async updateGL() {
      const { baseCrudKey } = this;
      const convertToIsoFromDate = this.criteriaState.fromDate
        ? toIsoDate(this.criteriaState.fromDate) : null;
      const convertToIsoToDate = this.criteriaState.toDate
        ? toIsoDate(this.criteriaState.toDate) : null;
      const glBusinessDate = this.criteriaState.glBusinessDate
        ? toIsoDate(this.criteriaState.glBusinessDate) : null;
      const criteria = {
        // ...this.criteriaState,
        ...{
          fromDate: convertToIsoFromDate,
          toDate: convertToIsoToDate,
          glBusinessDate,
          isUpdateGL: this.isUpdateGL,
          typeOfRecord: (this.criteriaState || {}).typeOfRecord || false,
        },
      };
      // const criteria = this.criteriaState;
      // manageGridLoading(this, true, 'Searching...');
      if (this.isUpdateGL) {
        const res = await this.apportionmnetUpdateRecordsInGL({ criteria, baseCrudKey });
        if (!res.status) {
          alert(res.message);
        } else {
          this.printGeneralLedgerReport(res.glUpdateToken);
          this.openGLDialog = false;
        }
      } else {
        this.printGeneralLedgerReport();
        this.openGLDialog = false;
      }
    },
    async printMoneyFromRecap() {
      if (this.isFiltersAvailable()) {
        const params = await this.getParamsData();
        const queryString = generateQueryString(params);
        const url = `${backendRest.defaults.baseURL}/reportBalancing/money-from-recap${queryString}`;
        window.open(url, '_blank');
      } else {
        this.flashWarn('Please select date range!');
      }
    },
    async printSectionAReport() {
      if (this.isFiltersAvailable()) {
        const params = await this.getParamsData();
        const queryString = generateQueryString(params);
        const url = `${backendRest.defaults.baseURL}/reportBalancing/section-a-summary${queryString}`;
        window.open(url, '_blank');
      } else {
        this.flashWarn('Please select date range!');
      }
    },
    async printGeneralLedgerReport(glUpdateToken) {
      if (this.isFiltersAvailable()) {
        const params = await this.getParamsData();
        if (glUpdateToken) {
          params.push(`glUpdateToken=${encodeURIComponent(glUpdateToken)}`);
        }
        const queryString = generateQueryString(params);
        const url = `${backendRest.defaults.baseURL}/reportBalancing/general-ledger-summary${queryString}`;
        window.open(url, '_blank');
      } else {
        this.flashWarn('Please select date range!');
      }
    },
    async printEONReport() {
      const params = await this.getParamsData();
      if (this.criteriaState.treasurerDate) {
        params.push(`treasurerDate=${toShortDate(this.criteriaState.treasurerDate)}`);
      }
      if (this.criteriaState.clerkDate) {
        params.push(`clerkDate=${toShortDate(this.criteriaState.clerkDate)}`);
      }
      if (this.criteriaState.exciseBoardDate) {
        params.push(`exciseBoardDate=${toShortDate(this.criteriaState.exciseBoardDate)}`);
      }
      if (this.criteriaState.isItSpecialApportionment) {
        params.push(`isItSpecialApportionment=${this.criteriaState.isItSpecialApportionment || false}`);
      }
      if (this.criteriaState.isCreateAppropriations) {
        await this.createEonAppropriations({
          criteria: {
            fromDate: toIsoDate(this.criteriaState.fromDate),
            toDate: toIsoDate(this.criteriaState.toDate),
            exciseBoardDate: toIsoDate(this.criteriaState.exciseBoardDate),
            isItSpecialApportionment: this.criteriaState.isItSpecialApportionment || false,
            isPrintTrial: (this.criteriaState || {}).typeOfRecord || false,
          },
        });
      }
      const queryString = generateQueryString(params);
      const url = `${backendRest.defaults.baseURL}/reportBalancing/estimate-of-need-summary${queryString}`;
      window.open(url, '_blank');
    },
    async printAlcoholicBeverageTaxReport() {
      if (this.isFiltersAvailable()) {
        const params = await this.getParamsData();
        const queryString = generateQueryString(params);
        const url = `${backendRest.defaults.baseURL}/apportionmnet/ABTReport${queryString}`;
        window.open(url, '_blank');
      } else {
        this.flashWarn('Please select date range!');
      }
    },
    async printFourMillReport() {
      if (this.isFiltersAvailable()) {
        const params = await this.getParamsData();
        const queryString = generateQueryString(params);
        const url = `${backendRest.defaults.baseURL}/reportBalancing/four-mill-summary${queryString}`;
        window.open(url, '_blank');
      } else {
        this.flashWarn('Please select date range!');
      }
    },
    async printMotorVehicleTaxreport() {
      if (this.isFiltersAvailable()) {
        const params = await this.getParamsData();
        const queryString = generateQueryString(params);
        const url = `${backendRest.defaults.baseURL}/apportionmnet/MVTReport${queryString}`;
        window.open(url, '_blank');
      } else {
        this.flashWarn('Please select date range!');
      }
    },
    async printBackPageSummary() {
      if (this.isFiltersAvailable()) {
        const params = await this.getParamsData();
        const queryString = generateQueryString(params);
        const url = `${backendRest.defaults.baseURL}/reportBalancing/back-page-summary${queryString}`;
        window.open(url, '_blank');
      } else {
        this.flashWarn('Please select date range!');
      }
    },
    async printCoverPageSummary() {
      const { jwt } = await this.reAuth();
      // const getcriteria = {
      //   ...this.criteriaState,
      // };
      // const encodedCriteria = encodeURIComponent(JSON.stringify(getcriteria));
      const params = [];
      // `filters=${encodedCriteria}`,
      // ,
      if (this.criteriaState.fromDate && this.criteriaState.toDate) {
        params.push(`fromDate=${toShortDate(this.criteriaState.fromDate)}`);
        params.push(`toDate=${toShortDate(this.criteriaState.toDate)}`);
        params.push(`coverPageDateReceived=${toShortDate(this.coverPageDateReceived)}`);
        params.push(`coverPageTitle=${this.coverPageTitle}`);
      }
      if (this.devSetting && this.devSetting.isTestEnvironment) {
        params.push('isTestCafe=1');
      }
      params.push(`token=${jwt}`);
      const queryString = generateQueryString(params);
      const url = `${backendRest.defaults.baseURL}/reportBalancing/cover-page-summary${queryString}`;
      window.open(url, '_blank');
      this.coverPageDialog = false;
    },
    openCreateWarrantDialog() {
      this.warrantDialog = true;
      this.criteriaState.remitToDate = this.criteriaState.toDate;
      this.criteriaState.remitFromDate = this.criteriaState.fromDate;
      const warrantDatetoShow = toIsoDate(this.criteriaState.warrantDate);
      this.$set(this.criteriaState, 'warrantDate', warrantDatetoShow);
      // this.criteriaState.warrantDate = toIsoDate(this.criteriaState.warrantDate);
    },
    openEONReportDialog() {
      if (this.isFiltersAvailable()) {
        this.$set(this.criteriaState, 'treasurerDate', toShortDate(this.todaysDate));
        this.$set(this.criteriaState, 'clerkDate', toShortDate(this.todaysDate));
        this.$set(this.criteriaState, 'exciseBoardDate', toShortDate(this.todaysDate));
        this.$set(this.criteriaState, 'isItSpecialApportionment', false);
        this.$set(this.criteriaState, 'isCreateAppropriations', false);
        this.EONReportDialog = true;
      } else {
        this.flashWarn('Please select date range!');
      }
    },
    openCoverPageDialog() {
      if (this.isFiltersAvailable()) {
        this.coverPageTitle = 'MONTHLY';
        this.coverPageDateReceived = toShortDate(this.todaysDate);
        this.coverPageDialog = true;
      } else {
        this.flashWarn('Please select date range!');
      }
    },
    async createWarrants() {
      this.criteriaState.remitFromDate = toIsoDate(this.criteriaState.remitFromDate);
      this.criteriaState.remitToDate = toIsoDate(this.criteriaState.remitToDate);
      this.criteriaState.warrantDate = toIsoDate(this.criteriaState.warrantDate);
      const criteria = {
        remitFromDate: this.criteriaState.remitFromDate,
        remitToDate: this.criteriaState.remitToDate,
        warrantDate: this.criteriaState.warrantDate,
      };
      await this.remitWarrantsBuildRecords({
        criteria,
      }).then(() => {
        this.warrantDialog = false;
      });
    },
    closeWarrantDialog() {
      this.warrantDialog = false;
    },
    closeEONReportDialog() {
      this.EONReportDialog = false;
    },
    emitSelectedItem(id) {
      this.selectedItems = id;
    },
    isFiltersAvailable() {
      return (this.criteriaState.fromDate && this.criteriaState.toDate);
    },
    newItemDialog() {
      let newItem = {};
      newItem = {
        fromDate: this.criteriaState.fromDate || '',
        toDate: this.criteriaState.toDate || '',
        isNormalRecord: true,
      };
      return newItem;
    },
    async getParamsData() {
      const { jwt } = await this.reAuth();
      const getcriteria = {
        ...this.criteriaState,
      };
      const params = [];
      if (this.criteriaState.fromDate && this.criteriaState.toDate) {
        params.push(`fromDate=${toShortDate(this.criteriaState.fromDate)}`);
        params.push(`toDate=${toShortDate(this.criteriaState.toDate)}`);
      } else {
        params.push(`fromDate=${toShortDate(new Date())}`);
        params.push(`toDate=${toShortDate(new Date())}`);
      }
      params.push(`isPrintTrial=${(this.criteriaState || {}).typeOfRecord || false}`);
      if (this.devSetting && this.devSetting.isTestEnvironment) {
        params.push('isTestCafe=1');
      }
      params.push(`token=${jwt}`);
      const encodedCriteria = encodeURIComponent(JSON.stringify(getcriteria));
      params.push(`filters=${encodedCriteria}`);
      return params;
    },
    async assignNexWarrantNumbers() {
      this.criteriaState.fromDate = toIsoDate(this.criteriaState.fromDate);
      this.criteriaState.toDate = toIsoDate(this.criteriaState.toDate);
      const criteria = {
        fromDate: this.criteriaState.fromDate,
        toDate: this.criteriaState.toDate,
      };
      this.manageGridLoading(this, true, 'Assigning Warrant Numbers...');
      try {
        await this.assignWarrantNumbers({ criteria });
        this.manageGridLoading(this, false);
        this.flashWarn('Warrant numbers assigned successfully.');
        this.getApportionmentRecords();
      } catch (error) {
        this.manageGridLoading(this, false);
        this.flashError('Failed to assign warrant numbers.');
      }
    },
  },
};
</script>

<style scoped>
.align-right {
display: flex;
justify-content: flex-end;
}
</style>
